import { lazyImport } from 'utils/LazyImport/LazyImport';
import { ComponentType } from 'react';

export type TRoute = {
  path: string;
  Component: ComponentType;
  queryArguments?: string[];
  redirects?: string[];
  hideMenu?: boolean;
  sorting?: number;
  redirectTo?: string;
};

export const Routes: Record<string, TRoute> = {
  home: {
    path: '/',
    Component: lazyImport(() => import('views/Home/Home')),
  },
  sleepPage: {
    path: '/sleep',
    Component: lazyImport(() => import('views/Sleep/SleepPage')),
  },
  contact: {
    path: '/contact',
    Component: lazyImport(() => import('views/Contact')),
  },
  terms: {
    path: '/terms',
    Component: lazyImport(() => import('views/Terms')),
  },
  imprint: {
    path: '/imprint',
    Component: lazyImport(() => import('views/Imprint')),
  },
  privacy: {
    path: '/privacy',
    Component: lazyImport(() => import('views/Privacy')),
  },
  loginConfirm: {
    path: '/login/:token',
    Component: lazyImport(() => import('views/LoginConfirm')),
    queryArguments: ['token'],
  },
  activationLink: {
    path: '/purchase/connect/:token',
    Component: lazyImport(() => import('views/ActivationLink')),
    queryArguments: ['token'],
  },

  resendToken: {
    path: '/resend_token',
    Component: lazyImport(() => import('views/Payment/Pricing/ResendToken/ResendToken')),
  },
  resendTokenB2b: {
    path: '/resend_token/b2b',
    Component: lazyImport(() => import('views/Payment/Pricing/ResendToken/ResendToken')),
    hideMenu: true,
  },
  categoriesFallback: {
    path: '/categories/*',
    Component: lazyImport(() => import('views/AppLinkNotFound')),
  },
  groupsFallback: {
    path: '/groups/*',
    Component: lazyImport(() => import('views/AppLinkNotFound')),
  },
  sleepFallback: {
    path: '/open/sleep/*',
    Component: lazyImport(() => import('views/AppLinkNotFound')),
  },

  voucherSuccess: {
    path: '/voucher_success',
    hideMenu: true,
    Component: lazyImport(() => import('views/RedeemVoucherSuccess')),
  },
  voucherLandingPage: {
    path: '/voucher',
    hideMenu: true,
    Component: lazyImport(() => import('views/B2BLandingPages/VoucherLandingpage')),
  },
  terminate: {
    path: '/terminate',
    Component: lazyImport(() => import('views/Terminate/Form/TerminateForm')),
  },
  terminateSuccess: {
    path: '/terminate/success',
    Component: lazyImport(() => import('views/Terminate/TerminateSuccess')),
  },
  trustPortal: {
    path: '/security',
    Component: lazyImport(() => import('View/Page/TrustPortalPage/TrustPortalPage')),
  }
};
